import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { setShow } from '../../../../../actions/general';
import { COURSE_DIRECT_PATH, GUEST_PATH, LOCAL_ORG_USER, POPUP_TYPE, SEAT_STATUS, SUBSCRIBER_PATH } from '../../../../../constants';
import { useActiveProduct } from '../../../../../helpers/customHook';
import { getFirstSellingGroupProductFromProduct, scrollToTopOffset, tryParseJSON } from '../../../../../utils';
import { fetchSubscriberProductsRequest } from '../../../Subscriber/Products/actions';
import { fetchOrganizationCoursesRequest } from '../../OrganizationCourses/actions';
import { fetchOrgMembersRequest } from '../../OrganizationMembers/actions';
import { fetchListOrganizationBundleSeatsRequest } from '../OrganizationSeats/actions';
import BundleSeatTable from './BundleSeatTable';
import { fetchOrganizationSeatsByFilterRequest } from './actions';

const BundleSeats = () => {
     const dispatch = useDispatch();
     const navigate = useNavigate();
     const location = useLocation();
     const { courseId } = useParams();

     const memberUsers = useSelector((state) => state.subscriber.organizationMembers);
     const listOrganizationBundleSeats = useSelector((state) => state.subscriber.listOrganizationBundleSeats);
     const organizationCourses = useSelector((state) => state.subscriber.organizationCourses);
     const products = useSelector((state) => state.subscriber.products.list);
     const organizationSeatsFilter = useSelector((state) => state.subscriber.organizationSeatsFilter);

     const [orgNotCourses, setOrgNotCourses] = useState(false);

     const organizationCourse = organizationCourses?.find((orgCourse) => orgCourse.id === courseId);
     const productId = organizationCourse?.productId;
     const orgUserLocalStorage = tryParseJSON(localStorage.getItem(LOCAL_ORG_USER));
     const organizationId = orgUserLocalStorage?.organizationId;

     const product = useActiveProduct(productId);
     const organizationOpenSeats = listOrganizationBundleSeats?.filter((orgSeat) => orgSeat.status === SEAT_STATUS.OPEN) ?? [];

     const fetchOrganizationCourses = async () => {
          if (!organizationId) return;

          const organizationCoursesData = await dispatch(fetchOrganizationCoursesRequest(organizationId));
          if (!organizationCoursesData?.length) {
               setOrgNotCourses(true);
          }
     };
     const fetchOrganizationMembers = () => {
          if (!memberUsers && organizationId) {
               dispatch(fetchOrgMembersRequest(organizationId));
          }
     };
     const fetchListOrganizationBundleSeats = () => {
          if (organizationId) {
               dispatch(fetchListOrganizationBundleSeatsRequest(organizationId, setOrgNotCourses));
          }
     };

     useEffect(() => {
          fetchOrganizationCourses();
          fetchOrganizationMembers();
          fetchListOrganizationBundleSeats();
     }, [organizationId]); // eslint-disable-line react-hooks/exhaustive-deps

     const fetchProducts = () => {
          if (!products.length) {
               dispatch(fetchSubscriberProductsRequest());
          }
     };

     useEffect(() => {
          scrollToTopOffset();
          fetchProducts();
     }, []); // eslint-disable-line react-hooks/exhaustive-deps

     const fetchOrganizationSeatsFilter = () => {
          const organizationCourseNew = organizationCourses?.find((orgCourse) => orgCourse.id === courseId);
          if (!organizationCourseNew) return;

          const isNeedFetchData =
               !organizationSeatsFilter ||
               (productId && organizationSeatsFilter.some((seat) => seat.productId !== productId)) ||
               (organizationId && organizationSeatsFilter.some((seat) => seat.organizationId !== organizationId));

          if (isNeedFetchData) {
               const query = {
                    productId,
               };
               dispatch(fetchOrganizationSeatsByFilterRequest({ organizationId, query, setOrgNotCourses }));
          }
     };
     useEffect(fetchOrganizationSeatsFilter, [organizationId, productId, organizationSeatsFilter]); // eslint-disable-line react-hooks/exhaustive-deps

     // Check trigger navigate organization dashboard
     useEffect(() => {
          let _orgNotCourseNew = false;
          const organizationCourseNew = organizationCourses?.find((orgCourse) => orgCourse.id === courseId);

          if (!organizationCourseNew) {
               _orgNotCourseNew = true;
          }

          if ((orgNotCourses && _orgNotCourseNew) || (organizationCourses?.length > 0 && _orgNotCourseNew)) {
               navigate(SUBSCRIBER_PATH.ORGANIZATIONS_DASHBOARD, { replace: true });
          }
     }, [organizationCourses, orgNotCourses]); // eslint-disable-line react-hooks/exhaustive-deps

     const handleBulkAddUsers = () => {
          dispatch(setShow(POPUP_TYPE.ASSIGN_MULTIPLE_USERS));
     };

     const handlePurchaseMoreSeats = () => {
          if (!!product?.preventPurchase) return;

          const locationPath = location.pathname;
          localStorage.setItem(COURSE_DIRECT_PATH, locationPath);

          const sellingGroupProduct = getFirstSellingGroupProductFromProduct(product?.sellingGroupProducts);
          const sellingGroupSlug = sellingGroupProduct?.sellingGroup?.slug;

          if (sellingGroupSlug) {
               navigate(GUEST_PATH.SELLING_GROUPS_DETAIL.replace(':slug', sellingGroupSlug));
          }
     };

     return (
          <section className="organization-layout manager-seats">
               <div className="heading">
                    <div className="content-heading">
                         <h5>Manage your seats for:</h5>
                         <h4>{product?.publishName ?? ''}</h4>

                         <p className="dn-heading">Add users to seats you have purchased.</p>
                    </div>
                    <div className="button-group-heading">
                         {organizationOpenSeats.length > 0 && (
                              <button type="button" className="btn btn-outline-blue-dark btn-arrow-right btn-bulk-add" onClick={handleBulkAddUsers}>
                                   Bulk Add Users
                              </button>
                         )}
                         <button
                              type="button"
                              className="btn btn-blue-dark btn-arrow-right"
                              disabled={!!product?.preventPurchase}
                              onClick={handlePurchaseMoreSeats}
                         >
                              Purchase More Seats
                         </button>
                    </div>
               </div>
               <BundleSeatTable />
          </section>
     );
};

export default BundleSeats;
